<template>
  <transition name="slide-fade">
    <div class="card">
      <div class="info">
        <div :style="{ backgroundImage: customerImageUrl ? 'url(' + customerImageUrl.replaceAll('(', '\\(').replaceAll(')', '\\)') + ')' : '' }" class='image-box'></div>
        <div>
          <div class='customer-info'>
            <span class='customer-name'>
              {{ customerName }}
            </span>
            회원님
            <span class='product-check-type'>
              {{ productCheckType }} 완료
            </span>
          </div>
          <div class='product-name'>
            {{ productName }}
          </div>
          <div class='product-expiredate'>
            {{ productExpireDate }}
          </div>
        </div>
      </div>
      <div class='card-time'>
        {{ dateTime }}
      </div>
    </div>
  </transition>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        customerName: {
            type: String,
        },
        productCheckType: {
            type: String,
        },
        customerImageUrl: {
            type: String,
        },
        productName: {
            type: String,
        },
        productExpireDate: {
            type: String,
        },
    },
  data() {
    return {
      limitTime: 5,
      dateTime: moment().format('HH:mm:ss'),
    };
  },
  created() {
      setInterval(() => this.getNow(), 1000)
  },
  mounted() {
    this.showCard();
  },
  methods: {
    showCard() {
      let timer = setInterval(() => {
          this.limitTime--;
          if(this.limitTime == 0) {
              clearInterval(timer);
              this.$emit('close-popup');
          }
      }, 1000);
    },
    getNow() {
        this.dateTime = moment().format('HH:mm:ss');
    },
  },
};
</script>

<style scoped>
.card {
  position: fixed;
  bottom: 24px;
  right: 20px;
  width: 520px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  border-radius: 8px;
  opacity: 1;
  transition: opacity 1s, transform 1s;
  z-index: 1000; /* 기본 z-index 값 */
  display: flex;
  justify-content: space-between;
}

.info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.customer-info {
  font-family: Noto Sans CJK KR;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.6000000238418579px;
  text-align: left;
  color: #535353;

  .customer-name {
    color: #0078F4;
  }

  .product-check-type {
    color: #3EC729;
  }
}

.product-name {
  font-family: Noto Sans CJK KR;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: -0.6000000238418579px;
  text-align: left;
  color: #535353;
}

.product-expiredate {
  font-family: Noto Sans CJK KR;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.6000000238418579px;
  text-align: left;
  color: #535353;
}

.image-box {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background-image: url(/img/icons/touch_user.png);
  background-position: center !important;
  background-size: contain;
  background-repeat: no-repeat;
}

.card-time {
  font-family: Noto Sans CJK KR;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.6000000238418579px;
  text-align: right;
  color: #535353;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 1s, transform 1s;
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

</style>
